export default __webpack_public_path__ + "static/media/Intimation of Earnings Call Q3 FY 25-26.e689e8dd.pdf";